'use strict';

var _extends = require('@babel/runtime/helpers/extends');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var _taggedTemplateLiteral = require('@babel/runtime/helpers/taggedTemplateLiteral');
require('react');
var shouldForwardProp = require('@styled-system/should-forward-prop');
var styledSystem = require('styled-system');
var styled = require('@emotion/styled');
var react = require('@emotion/react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var _taggedTemplateLiteral__default = /*#__PURE__*/_interopDefaultLegacy(_taggedTemplateLiteral);
var shouldForwardProp__default = /*#__PURE__*/_interopDefaultLegacy(shouldForwardProp);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var _excluded = ["children", "size", "color"];
var _templateObject;
var withIconProps = function withIconProps(Component) {
  var IconStyled = styled__default["default"](Component, {
    shouldForwardProp: shouldForwardProp__default["default"]
  })(_templateObject || (_templateObject = _taggedTemplateLiteral__default["default"](["\n        height: ", ";\n        width: ", ";\n        ", ";\n        ", ";\n    "])), function (_ref) {
    var theme = _ref.theme,
      size = _ref.size;
    return theme.sizes[size] || size + 'px';
  }, function (_ref2) {
    var theme = _ref2.theme,
      size = _ref2.size;
    return theme.sizes[size] || size + 'px';
  }, styledSystem.margin, styledSystem.color);
  return function (_ref3) {
    var children = _ref3.children,
      _ref3$size = _ref3.size,
      size = _ref3$size === void 0 ? 'icon-medium' : _ref3$size,
      _ref3$color = _ref3.color,
      color = _ref3$color === void 0 ? 'icon-global-primary' : _ref3$color,
      restProps = _objectWithoutProperties__default["default"](_ref3, _excluded);
    return react.jsx(IconStyled, _extends__default["default"]({
      size: size,
      color: color
    }, restProps), children);
  };
};

exports.withIconProps = withIconProps;
//# sourceMappingURL=withIconProps-365ff8d5.js.map
